<template>
  <v-card>
    <!-- 密碼修改 -->
    <v-toolbar>
      <v-toolbar-title>密碼修改</v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      <v-container fluid>
        <v-row row>
          <v-col xs4>
            <v-subheader>密碼</v-subheader>
          </v-col>
          <v-col xs8>
            <v-text-field
              name="input-2-5"
              label="密碼"
              v-model="password"
              class="input-group"
              single-line
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row row>
          <v-col xs4>
            <v-subheader>密碼確認</v-subheader>
          </v-col>
          <v-col xs8>
            <v-text-field
              name="input-3-5"
              label="密碼確認"
              value=""
              v-model="confirm"
              class="input-group"
              single-line
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>
      <v-card-row actions class="mt-4">
        <v-btn small primary dark>更新</v-btn>
      </v-card-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {

    name: 'MyPassword',

    data () {
      return {
        password: '',
        confirm: ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// MyPassword.vue?5f9552a9